// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hTitle":"k0E1g","couponTitle":"_0nQX-","title":"ISjUN","enableTextTransform":"L13TQ","disableTextTransform":"IS4lL"};